/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_PER_APPLIED_ITEM = {
  id: 'perception_applied',
  screenId: 'tax-per-applied',
  label: 'Percepciones',
  description: 'Consulta de percepciones aplicadas en facturas de venta.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Listado de solo lectura: percepciones que el sistema calculó al emitir facturas de venta en un rango de fechas. Sirve para controlar y presentar DDJJ de agente de percepción.',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Impuesto', description: 'Todos los del agente o uno en particular.' },
          { label: 'Desde / Hasta', description: 'Rango de fechas de la factura. Obligatorio para buscar.' },
        ],
        paragraphs: ['Tocá «Buscar». Por defecto trae el mes en curso.'],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Fecha, Comprobante, Cliente, Impuesto, Alícuota, Base, Importe, Moneda.',
          'Podés exportar la grilla. No se editan desde acá: surgen de las facturas emitidas.',
        ],
      },
    ],
  },
}
